import { all, takeEvery, put, call } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import * as actionTypes from '../constants/actionTypes';
import * as jobAction from '../actions';

import axios from '../services';
import toaster from '../utils/toaster';

function* createJobRequest({ payload, meta }) {
  try {
    yield put(jobAction.showLoader());

    let response = yield axios.post('/job/create', {
      ...payload,
    });

    yield put(jobAction.hideLoader());

    if (response.status === 200) {
      yield put(jobAction.jobRequestSuccess(response.data.data));
      toaster(response.data.message);
      if (typeof meta?.onSuccess === 'function') {
        meta.onSuccess(response.data.data, response.data);
      }
    } else {
      toaster(response.data.message);
      if (typeof meta?.onError === 'function') {
        meta.onError(response.data);
      }
    }
  } catch (error) {
    yield put(jobAction.hideLoader());
    // yield localStorage.clear();
    toaster(error, { type: 'error' });
    if (typeof meta?.onError === 'function') {
      meta.onError(error);
    }
    // yield put(jobAction.logoutRequestSuccess(true));
  }
}

/** Refresh jobs list; exported so invoice/expense sagas can `yield call(...)` and await Redux updates. */
export function* fetchAllJobsWorker() {
  try {
    yield put(jobAction.showLoader());
    const response = yield axios.get('/job/view/all');
    if (response.status === 200) {
      yield put(jobAction.allJobRequestSuccess(response.data));
    } else {
      toaster(response.data.message, { type: 'error' });
    }
    yield put(jobAction.hideLoader());
  } catch (error) {
    yield put(jobAction.hideLoader());
    if (error == 'Error: Request failed with status code 401') {
      yield put(push('/sign-in'));
      toaster(error, { type: 'error' });
    }
  }
}

function* allJobRequest() {
  yield call(fetchAllJobsWorker);
}

function* getJobRequest(payload) {
  try {
    const { gcnNo } = payload;
    yield put(jobAction.showLoader());

    let response = yield axios.get(`/job/view?gcnno=${gcnNo}`);

    if (response.status === 200) {
      yield put(jobAction.getJobRequestSuccess(response.data));
      yield put(jobAction.hideLoader());
      toaster(response.data.message);
    } else {
      yield put(jobAction.hideLoader());
      toaster(response.data.message, { type: 'error' });
    }
  } catch (error) {
    yield put(jobAction.hideLoader());
    if (error == 'Error: Request failed with status code 401') {
      yield localStorage.clear();
      toaster('Signing out ...', { type: 'error' });
      yield put(jobAction.logoutRequestSuccess(true));
    }
  }
}

function* updateJobRequest(action) {
  try {
    const { gcnno, payload, meta } = action;
    if (!gcnno) {
      toaster('Missing job reference', { type: 'error' });
      return;
    }
    const response = yield axios.post(`/job/update?gcnno=${encodeURIComponent(gcnno)}`, {
      ...payload,
    });

    if (response.status === 200) {
      yield put(jobAction.updateJobRequestSuccess(response.data));
      toaster(response.data.message);
      if (typeof meta?.onSuccess === 'function') {
        meta.onSuccess(response.data);
      } else {
        yield call(fetchAllJobsWorker);
      }
    } else {
      toaster(response.data.message, { type: 'error' });
    }
  } catch (error) {
    if (error == 'Error: Request failed with status code 401') {
      yield localStorage.clear();
      toaster('Signing out ...', { type: 'error' });
      yield put(jobAction.logoutRequestSuccess(true));
    }
  }
}

function* deleteJobRequest(payload) {
  try {
    console.log("Payload", payload);

    const { gcnNo } = payload;
    yield put(jobAction.showLoader());
    let response = yield axios.post(`/job/delete?gcnno=${gcnNo}`);
    if (response.status === 200) {
      yield put(jobAction.deleJobRequestSuccess(response.data));
      yield call(fetchAllJobsWorker);
      yield put(jobAction.hideLoader());
      toaster(response.data.message);
    } else {
      toaster(response.data.message, { type: 'error' });
      yield put(jobAction.hideLoader());
    }
  } catch (error) {
    yield put(jobAction.hideLoader());
    if (error == 'Error: Request failed with status code 401') {
      yield localStorage.clear();
      toaster('Signing out ...', { type: 'error' });
      yield put(jobAction.logoutRequestSuccess(true));
    }
    toaster(error, { type: 'error' });
  }
}

function* updateJobStatusRequest(payload) {
  try {
    const {
      payload: { status, gcnNo },
    } = payload;
    let response = yield axios.post(`/job/update?gcnno=${gcnNo}`, { status });
    yield put(jobAction.showLoader());
    if (response.status === 200) {
      yield put(jobAction.updateJobStatusRequestSuccess(response.data));
      yield call(fetchAllJobsWorker);
      yield put(jobAction.hideLoader());
      toaster(response.data.message);
    } else {
      yield put(jobAction.hideLoader());
      toaster(response.data.message, { type: 'error' });
    }
  } catch (error) {
    yield put(jobAction.hideLoader());
    if (error == 'Error: Request failed with status code 401') {
      yield localStorage.clear();
      toaster('Signing out ...', { type: 'error' });
      yield put(jobAction.logoutRequestSuccess(true));
    }
  }
}

export default function* rootsaga() {
  yield all([
    yield takeEvery(actionTypes.CREATE_JOB_REQUEST, createJobRequest),
    yield takeEvery(actionTypes.GET_JOB_REQUEST, getJobRequest),
    yield takeEvery(actionTypes.GET_ALL_JOB_REQUEST, allJobRequest),
    yield takeEvery(actionTypes.UPDATE_JOB_REQUEST, updateJobRequest),
    yield takeEvery(actionTypes.DELETE_JOB_REQUEST, deleteJobRequest),
    yield takeEvery(actionTypes.UPDATE_JOB_STATUS_REQUEST, updateJobStatusRequest),
  ]);
}
